import _ from 'lodash'
import { globalStore } from '@store/index'
import { GlobalStoreKey } from '@v2/constants/common'

export const DEFAULT_EFFECT_ICON_ID = 'effect_01'

export interface EffectIcon {
  id: string
  name: string
  img: string
  pvImg: string
  pvGrayImg?: string
  stopImg: string
  oneTimePlayImg: string
}

export function getCheerForTeamEffectIconList(): EffectIcon[] {
  const imageUrl = globalStore.findGlobalSetting(GlobalStoreKey.INGAME_IMAGES_URL).value
  const effectIconImg01 = `${imageUrl}effectIcons/img/effect_01.gif`
  const effectIconImg02 = `${imageUrl}effectIcons/img/effect_02.gif`
  const effectIconImg03 = `${imageUrl}effectIcons/img/effect_03.gif`
  const effectIconImg04 = `${imageUrl}effectIcons/img/effect_04.gif`
  const effectIconPvImg01 = `${imageUrl}effectIcons/pvImg/effect_01.png`
  const effectIconPvImg02 = `${imageUrl}effectIcons/pvImg/effect_02.png`
  const effectIconPvImg03 = `${imageUrl}effectIcons/pvImg/effect_03.png`
  const effectIconPvImg04 = `${imageUrl}effectIcons/pvImg/effect_04.png`
  const effectIconPvGrayImg01 = `${imageUrl}effectIcons/pvImg/effect_gray_01.png`
  const effectIconPvGrayImg02 = `${imageUrl}effectIcons/pvImg/effect_gray_02.png`
  const effectIconPvGrayImg03 = `${imageUrl}effectIcons/pvImg/effect_gray_03.png`
  const effectIconPvGrayImg04 = `${imageUrl}effectIcons/pvImg/effect_gray_04.png`
  const effectIconStopImg01 = `${imageUrl}effectIcons/img/effect_stop_01.png`
  const effectIconStopImg02 = `${imageUrl}effectIcons/img/effect_stop_02.png`
  const effectIconStopImg03 = `${imageUrl}effectIcons/img/effect_stop_03.png`
  const effectIconStopImg04 = `${imageUrl}effectIcons/img/effect_stop_04.png`
  const effectIconOneTimePlayImg01 = `${imageUrl}effectIcons/img/effect_one_time_play_01.gif`
  const effectIconOneTimePlayImg02 = `${imageUrl}effectIcons/img/effect_one_time_play_02.gif`
  const effectIconOneTimePlayImg03 = `${imageUrl}effectIcons/img/effect_one_time_play_03.gif`
  const effectIconOneTimePlayImg04 = `${imageUrl}effectIcons/img/effect_one_time_play_04.gif`

  return [
    {
      id: DEFAULT_EFFECT_ICON_ID,
      name: '가즈아',
      img: effectIconImg01,
      pvImg: effectIconPvImg01,
      pvGrayImg: effectIconPvGrayImg01,
      stopImg: effectIconStopImg01,
      oneTimePlayImg: effectIconOneTimePlayImg01,
    },
    {
      id: 'effect_02',
      name: '좋아',
      img: effectIconImg02,
      pvImg: effectIconPvImg02,
      pvGrayImg: effectIconPvGrayImg02,
      stopImg: effectIconStopImg02,
      oneTimePlayImg: effectIconOneTimePlayImg02,
    },
    {
      id: 'effect_03',
      name: '실망',
      img: effectIconImg03,
      pvImg: effectIconPvImg03,
      pvGrayImg: effectIconPvGrayImg03,
      stopImg: effectIconStopImg03,
      oneTimePlayImg: effectIconOneTimePlayImg03,
    },
    {
      id: 'effect_04',
      name: '분노',
      img: effectIconImg04,
      pvImg: effectIconPvImg04,
      pvGrayImg: effectIconPvGrayImg04,
      stopImg: effectIconStopImg04,
      oneTimePlayImg: effectIconOneTimePlayImg04,
    },
  ]
}

export function getDefaultCheerForTeamEffectIcon(): EffectIcon {
  return _.find(getCheerForTeamEffectIconList(), { id: DEFAULT_EFFECT_ICON_ID })
}

export function findEffectIconId(effectIconUrl: string): string {
  const effectIcon = _.find(getCheerForTeamEffectIconList(), (icon) =>
    icon.stopImg === effectIconUrl || icon.img === effectIconUrl)
  return effectIcon ? effectIcon.id : DEFAULT_EFFECT_ICON_ID
}

export function findStopEffectIconImgCheerForTeam(effectIconUrl: string): string {
  const effectIconId = findEffectIconId(effectIconUrl)
  const selectedEffect = _.find(getCheerForTeamEffectIconList(), { id: effectIconId })
  return selectedEffect.stopImg
}

export function findOneTimePlayEffectIconImgCheerForTeam(effectIconUrl: string): string {
  const effectIconId = findEffectIconId(effectIconUrl)
  const selectedEffect = _.find(getCheerForTeamEffectIconList(), { id: effectIconId })
  return selectedEffect.oneTimePlayImg
}

